<template>
  <v-flex xs12>
    <v-card>
      <v-card-title>
        <div class="flex-container-space-between">
          <layout-no-padding>
            <page-title :routeProps="routeProps"></page-title>
          </layout-no-padding>

          <div class="text-xs-right">
            <v-btn icon flat color="grey" class="mr-0" @click="drawer = !drawer">
              <v-icon>playlist_add</v-icon>
            </v-btn>
          </div>
        </div>
        <filter-drawer></filter-drawer>
      </v-card-title>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12 sm6 md4>
            <v-autocomplete
              :prepend-icon="$store.state.global.pages.audit.icon"
              :color="$store.state.global.pages.audit.color"
              label="Model"
              :items="models"
              v-model="model"
              item-text="text"
              :clearable="true"
              item-value="value"
            >
              <template slot="item" slot-scope="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
                  <v-list-tile-avatar>
                    <v-icon
                      :color="$store.state.global.pages[data.item.icon].color"
                    >{{$store.state.global.pages[data.item.icon].icon}}</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.text"></v-list-tile-title>
                    <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field
              :prepend-icon="icon"
              :color="color"
              :label="`${!!modelObj ? this.modelObj.text : 'Model'} ID`"
              v-model="subjectId"
              v-if="textFieldRequired"
            ></v-text-field>
            <v-autocomplete
              :prepend-icon="icon"
              :color="color"
              :label="!!modelObj ? modelObj.text : 'Please select a model'"
              :items="subjects"
              v-model="subjectId"
              :item-text="!!modelObj ? modelObj.nameField : null"
              :clearable="true"
              item-value="id"
              :loading="loading"
              v-else
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
      <div class="mx-3 mb-5">
        <card-divider-full></card-divider-full>
      </div>
      <v-card-actions></v-card-actions>
      <v-btn
        fab
        dark
        :color="$store.state.global.pages[$route.name].color"
        class="overlap-fab"
        @click="addDialog = !addDialog"
        v-if="userAuthClass"
      >
        <v-icon dark>add</v-icon>
      </v-btn>
    </v-card>
  </v-flex>
</template>

<script>
import Store from '@/store/computed/storeHelpers'

// MIXINS
import RouteProps from '@/services/mixins/routeProps'
import models from './mixins/models'
import getContractors from '@/services/mixins/getMasterFiles/getContractors'
import getVehicles from '@/services/mixins/getMasterFiles/getVehicles'
import getDrivers from '@/services/mixins/getMasterFiles/getDrivers'
// import getRates from '@/services/mixins/getMasterFiles/getRates'
import getSites from '@/services/mixins/getMasterFiles/getSites'
import getClients from '@/services/mixins/getMasterFiles/getClients'
import getProjects from '@/services/mixins/getMasterFiles/getProjects'
import getSpoils from '@/services/mixins/getMasterFiles/getSpoils'
import getTips from '@/services/mixins/getMasterFiles/getTips'
// COMPONENTS
import FilterDrawer from '@/modules/complianceResources/filterDrawer'

export default {
  mixins: [
    RouteProps,
    models,
    getClients,
    getProjects,
    getSites,
    getSpoils,
    getTips,
    getContractors,
    getVehicles,
    getDrivers
    // getRates
  ],
  components: {
    FilterDrawer
  },
  data() {
    return {
      addDialog: false,
      loading: false
    }
  },
  computed: {
    subjectId: Store.getSet({ store: 'audits', prop: 'subjectId' }),
    model: Store.getSet({ store: 'audits', prop: 'model' }),
    subjects: Store.getSet({ store: 'audits', prop: 'subjects' }),
    modelObj() {
      if (!!this.model) {
        return this.getObjByProp(this.model, 'value', this.models)
      } else {
        return null
      }
    },
    textFieldLabel() {
      return `${this.modelObj.text} ID`
    },
    textFieldRequired() {
      if (!!this.modelObj) {
        if (this.modelObj.type === 'transaction') return true
      }
      return false
    },
    color() {
      return !!this.modelObj
        ? this.$store.state.global.pages[this.modelObj.icon].color
        : this.$store.state.global.pages.client.color
    },
    icon() {
      return !!this.modelObj
        ? this.$store.state.global.pages[this.modelObj.icon].icon
        : this.$store.state.global.pages.client.icon
    }
  },
  watch: {
    model(val) {
      if (!val) {
        this.subjectId = null
        this.subjects = []
      } else {
        this.getData(val)
      }
    }
  },
  methods: {
    async getData(model) {
      switch (model) {
        case 'client':
          this.subjects = await this.getClients()
          this.clearMasterFiles()
          break
        case 'project':
          this.subjects = await this.getProjects()
          this.clearMasterFiles()
          break
        case 'site':
          this.subjects = await this.getSites()
          this.clearMasterFiles()
          break
        case 'spoil':
          this.subjects = await this.getSpoils()
          this.clearMasterFiles()
          break
        case 'tip':
          this.subjects = await this.getTips()
          this.clearMasterFiles()
          break
        case 'contractor':
          this.subjects = await this.getContractors()
          this.clearMasterFiles()
          break
        case 'vehicle':
          this.subjects = await this.getVehicles()
          this.clearMasterFiles()
          break
        case 'driver':
          this.subjects = await this.getDrivers()
          this.clearMasterFiles()
          break
      }
    },
    clearMasterFiles() {
      for (const modelObject of this.models) {
        if (modelObject.value !== this.model) this[`${modelObject.value}s`] = []
      }
    }
  }
}
</script>

<style scoped>
.overlap-fab-compliance {
  right: 40px;
  bottom: -17px;
  position: absolute !important;
}
</style>


